import { api } from './api';

// GitHub App - Organization Level
export const getGithubInstallUrl = async (orgId) => {
  const response = await api.get(`/github/${orgId}/install-url`);
  return response.data;
};

export const getGithubStatus = async (orgId) => {
  const response = await api.get(`/github/${orgId}/status`);
  return response.data;
};

export const disconnectGithub = async (orgId) => {
  const response = await api.delete(`/github/${orgId}/disconnect`);
  return response.data;
};

// Manual PR link fallback - Scope Level
export const linkPullRequest = async (scopeId, url) => {
  const response = await api.post(`/github/scopes/${scopeId}/pull-requests`, { url });
  return response.data;
};

export const unlinkPullRequest = async (scopeId, linkId) => {
  const response = await api.delete(`/github/scopes/${scopeId}/pull-requests/${linkId}`);
  return response.data;
};

const githubApi = {
  getGithubInstallUrl,
  getGithubStatus,
  disconnectGithub,
  linkPullRequest,
  unlinkPullRequest,
};

export default githubApi;
